import { useReportMutations } from "@app/entities/report/mutations";
import { T_Report } from "@app/entities/report/types";
import Form from "antd/lib/form";
import { useState } from "react";

type Args = {
  reportId: number;
  onSuccess?: () => void;
};

export const useReportFormSubmit = ({ reportId, onSuccess }: Args) => {
  const [file, setFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [reportForm] = Form.useForm();
  const { updateReport, isMutationPending } = useReportMutations();

  const handleSubmit = (report: T_Report) => {
    updateReport(
      { ...report, reportId, file },
      { onSuccess: () => onSuccess?.() },
    );
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onload = () => setPreviewUrl(reader.result as string);
      reader.readAsDataURL(selectedFile);
    }
  };

  return {
    reportForm,
    file,
    previewUrl,
    handleFileChange,
    handleSubmit,
    isSubmitting: isMutationPending,
  };
};
